import Api from '@/api/api'
import configApi from '@/api/config/_api_config'

export default {
    async read(path, params) {
        const access = await configApi().post('/admin/medical-activity-access', {}, { timeout: 15000, admin_dashboard_scoped: true })
        const token = access && access.data && access.data.data && access.data.data.access_token
        if (!token) throw new Error('Accès administrateur indisponible.')
        const response = await Api().get('/v1/admin/medical-activity/' + path, {
            params, timeout: 20000, med_access_scoped: true,
            headers: { 'X-Admin-Medical-Activity-Access': token }
        })
        return response.data
    }
}

